import { BUILD } from './build';

export const APP = {
    name: 'Apple Music Classical',
    version: '1.0',
    build: BUILD,
    bundleId: 'com.apple.music.Classical',
};

// As source type will be different for each Media APP it is defined here as a Config
export const PAF_CONFIG = {
    sourceType: 16,
};
